import React from "react";
import { useHistory } from "react-router";
import { useIntl } from "react-intl";

import Icons from "../../../icons";
import Icon from "../../../icon";

import { UpperMenu, MenuLeft, ArrowButton, Logo } from "./styles";
import messages from "./messages";

const Menu = () => {
    const history = useHistory();
    const { formatMessage, locale } = useIntl();
    return (
        <UpperMenu>
            <MenuLeft>
                <ArrowButton
                    onClick={() => {
                        if (window.historyList.length === 0) {
                            history.push("/");
                        } else {
                            history.goBack();
                        }
                    }}
                >
                    <Icon i="arrowback" />
                </ArrowButton>
                <Logo to="/">
                    <Icons.Logo slogen={formatMessage(messages.slogen)} locale={locale} />
                </Logo>
            </MenuLeft>
        </UpperMenu>
    );
}

export default Menu;
